import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { getDiscountByAmount } from './utils';
import { DISCOUNTS_BY_AMOUNT } from '../../../config';

const CartAlert = (props) => {
  const couponValue = props.coupon ? props.coupon.value : 0;

  const discountByAmount = getDiscountByAmount(props.fullPriceCheckedCount);
  const alerts = {
    'byAmount': {
      'title': gettext('Скидка за единовременную покупку'),
      'value': discountByAmount,
      'message': getMessageToUserAboutDiscountByAmount(props.count, props.fullPriceCheckedCount),
    },
    'byCoupon': {
      'title': gettext('Скидка по промокоду'),
      'value': couponValue,
    },
    'byUser': {
      'title': gettext('Персональная скидка'),
      'value': props.exclusiveDiscount,
    }
  }

  const [alert, setAlert] = useState(alerts['byAmount']);
  useEffect(() => {
    let maxValue = Math.max(discountByAmount, couponValue, props.exclusiveDiscount);
    switch (maxValue) {
      case 0:
        setAlert(null);
        break;
      case discountByAmount:
        setAlert({...alerts['byAmount'],
                        'message': getMessageToUserAboutDiscountByAmount(props.count, props.fullPriceCheckedCount)});
        break;
      case couponValue:
        setAlert(alerts['byCoupon']);
        break;
      case props.exclusiveDiscount:
        setAlert(alerts['byUser']);
        break;
      default:
        setAlert(null);
    }
  }, [props.fullPriceCheckedCount, props.coupon])

  function getMessageToUserAboutDiscountByAmount(count, fullPriceCheckedCount){
    let msg = '';
    let discount_key = 3;

    if ([2, 4, 6, 7, 8, 9, 16, 17, 18, 19].includes(fullPriceCheckedCount)) {
      if (count === fullPriceCheckedCount) {
        msg = gettext('Добавьте в корзину еще');
      } else {
        msg = gettext('Выберете для оплаты еще');
      }
      if ([2, 4, 9, 19].includes(fullPriceCheckedCount)) {
        msg = msg + ' ' + gettext('один товар');
        discount_key = fullPriceCheckedCount + 1;
      } else if ([6, 16].includes(fullPriceCheckedCount)) {
        msg = msg + ' ' + gettext('четыре товара');
        discount_key = fullPriceCheckedCount + 4;
      } else if ([7, 17].includes(fullPriceCheckedCount)) {
        msg = msg + ' ' + gettext('три товара');
        discount_key = fullPriceCheckedCount + 3;
      } else if ([8, 18].includes(fullPriceCheckedCount)) {
        msg = msg + ' ' + gettext('две товара');
        discount_key = fullPriceCheckedCount + 2;
      }
      if (fullPriceCheckedCount === 2) {
        msg = msg + ' ' + gettext('и получите скидку');
      } else {
        msg = msg + ' ' + gettext('и увеличьте скидку до');
      }
      msg = msg + ' ' + DISCOUNTS_BY_AMOUNT[discount_key] + '%';
    }
    return msg;
  }

  if (alert){
    return (
      <Alert variant="success">
        <div>{ alert.title }: {' '}
          <span className="font-weight-bold">{ alert.value + '%' }</span>
        </div>
        { alert.message && <div>{ alert.message }</div> }
        <div className="small text-muted">
          { alert.title } { gettext('распростроняется только на товары без скидки.') }</div>
      </Alert>
    );
  }
  return <></>
};

CartAlert.propTypes = {
    count: PropTypes.number.isRequired,
    fullPriceCheckedCount: PropTypes.number.isRequired,
    coupon: PropTypes.object.isRequired,
    exclusiveDiscount: PropTypes.number.isRequired,
}

export default CartAlert;